import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_auto_email_rule_reports_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { ruleContext: string, excludeReports?: string[], $top?: number, $skip?: number }): Promise<{ result?: { reportName?: string, label?: string }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.ruleContext)) {
      missingRequiredInParams.push('\'ruleContext\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_auto_email_rule_reports_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ruleContext?: string, excludeReports?: string[], $keys: string[] }): Promise<{ result?: { reportName?: string, label?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_auto_email_rule_reports_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      ruleContext: string, excludeReports?: string[]    }) {
        if(isNil(inParams.ruleContext)) {
          return true; 
        }
      return false;
    }
}
